
import { TemperatureLogEnum } from "@gtpl/shared-models/common-models";
import appSettings from "apps/services/config";
import { EntityRepository, Repository } from "typeorm";
import { Temperatures } from "../dto/temp-log.model";
import { TemperatureLog } from "../entity/temperature-log.entity";
import { CurrentTempQueryResponse, DayWiseTempQueryResponse, TemperatureQueryResponse, UidResponse } from "../response/temperature-query.response";

@EntityRepository(TemperatureLog)
export class TemperatureLogRepository extends Repository<TemperatureLog>{

  constructor() {
    super();
  }

  /**
   * 
   * @param date 
   * @param deptName 
   * @returns 
   */

  async getTemperaturesLogByDate(date: Date, deptName: string): Promise<TemperatureQueryResponse[]> {
    const query = this.createQueryBuilder('temperature_log')
      .select(`dept_name , DATE(date) ,temperature,module,sub_module,hour,minutes,uom`)
      .where(`DATE(date) = '${date}' `)
    if (deptName) {
      query.andWhere(` dept_name  = '${deptName}' `)
    }
    query.groupBy('dept_name, hour')
      .orderBy('date', 'DESC')
    return await query.getRawMany();
  }

  async getTempHour(date: string, hour: number, deptCode: string,uid:string, minutes?: number,): Promise<CurrentTempQueryResponse[]> {
    const query = this.createQueryBuilder('temperature_log')
      .select(`temperature,hour,uom,date,dept_code`)
      .where(` DATE(date) = '${date}' `)
    if (deptCode) {
      query.andWhere(` dept_code = '${deptCode}' `)
    }
    query.groupBy('dept_code')
      .orderBy('date', 'DESC')
    return await query.getRawMany();
  }

  async getDayWiseTempByDept(deptCode: string, month: number, startDate: string, endDate: string,uid:string): Promise<DayWiseTempQueryResponse[]> {
    const query = this.createQueryBuilder('temperature_log')
      .select(`MAX(temperature) as highest_temperature,MIN(temperature) as lowest_temperature,date,dept_name `)
      .where(`Date(date) between '${startDate}' and '${endDate}' `)
    if (deptCode) {
      query.andWhere(` dept_code = '${deptCode}' `)
    }
    query.groupBy('DATE(date)')
      .orderBy('date', 'DESC')
    return await query.getRawMany();
  }

  async getUidDetails(uid: string): Promise<UidResponse[]> {
    const query = this.createQueryBuilder('temperature_log')
      .select(`temperature , load_status , date , uid`)
      .where(`uid = '${uid}'`)
    return await query.getRawMany();
  }
}